module.exports = __webpack_public_path__ + "static/media/AutorisationdroitimageMiniM.7c92d0de.pdf";